import { ServiceBase, IBaseEntity } from './ServiceBase';

export interface Series extends IBaseEntity {}

export class SeriesService extends ServiceBase<Series> {
  constructor() {
    super('series');
  }
}

const seriesServiceInstance = new SeriesService();

export default seriesServiceInstance;
